/*global Calendly */
import {
  tourSubmission,
  submissionBigTeam,
  bookATourPartnerize,
  applicationPartnerize,
} from "../gtm";

import { resetSubmissionText } from "../submit/util";

export const showConfirmationScreen = (formName) => {
  //  find all the instances of the same form (embed and modal)
  const $forms = $(`form[name=${formName}]`);

  $forms.each((_, form) => {
    const $form = $(form);
    const $formFieldWrapper = $form.find(".js-form-fields");
    const $formSubmissionButton = $form.find(".btn.submit ");

    if ($form.hasClass("js-clear-form")) {
      window._form = $form[0];
      window._name = $form[0].querySelector('[name="FirstName"]')
        ? $form[0].querySelector('[name="FirstName"]').value
        : false;

      $form[0].reset();
      $form.find(".field-wrap").removeClass("good");
      if ($form.find(".js-global-access-message-wrapper")) {
        $form.find(".js-global-access-message-wrapper").text("");
      }

      if (!$(".modal.show").length) {
        if ($("#modal-thank-you").length) {
          $("#modal-thank-you").modal("show");
        }
      }

      resetSubmissionText($formSubmissionButton);
    } else {
      if ($("calendly").length) {
        $("#modal-location-form").modal("show");
      }
      //  change the header and subheader to confirmation text
      //  cannot use $ because there could be multiple forms
      const isFormInModal = $form.parents().hasClass("modal-body");
      const $formWrapper = isFormInModal
        ? $form.parents(".modal-content")
        : $form.parent();

      const $confirmationTextsEls = $formWrapper.find(
        ".subhead, .section-header, .form-subhead, .js-form-confirmation"
      );

      $confirmationTextsEls.each((_, el) => {
        const $el = $(el);
        $el
          .html($el.data("confirmation"))
          .addClass("confirmed")
          .removeClass("d-none")
          .css({
            margin: "0 auto 15px",
            "text-align": "center",
          });
      });

      //  for landlord form and broker form, hide other text elements
      $formWrapper.find(".text-md-left").hide();

      //  for book a tour form on landlord
      $formWrapper.find(".rounded-tag-wrapper").hide();

      //  for collapsed froms on contact-us, hide the card description
      if ($formWrapper.hasClass("form-wrapper")) {
        $formWrapper.prev().hide();
      }

      //  hide the form
      $form.hide();

      $formFieldWrapper
        .delay(500)
        .fadeOut(250)
        .queue(function () {
          $(this).hide().dequeue();
          $(".scroll-wrapper").scrollTop(0);
        });
    }
  });
};

export const showConfirmationFooterNewsletter = ($form) => {
  const $formFields = $form.find(".js-form-fields");

  const $confirmationTextsEl = $form
    .parent()
    .parent()
    .find(".newsletter-confirmation");

  $confirmationTextsEl.each((_, el) => {
    const $el = $(el);
    $el.text($el.data("confirmation"));
    $el.addClass("confirmed");
  });

  $formFields.hide();

  $formFields
    .delay(500)
    .fadeOut(250)
    .queue(function () {
      $(this).hide().dequeue();
    });
};

export const createTourFormZapierBody = (formValues) => {
  const requiredFields = [
    "FirstName",
    "LastName",
    "Email",
    "Phone",
    "Company",
    "commentCapture",
    "Office_Size2__c",
    "Reference_Code__c",
  ];

  return requiredFields.reduce((acc, key) => {
    if (formValues[key]) {
      acc[key] = formValues[key];
    }
    return acc;
  }, {});
};

export const tourFormTracking = (size) => {
  tourSubmission();
  window.uetq = window.uetq || [];
  window.uetq.push({
    ec: "Forms",
    ea: "Submit",
    el: "Tour Booking",
    ev: 1,
  });

  const excludedSizes = ["1-4", "5-19"];

  if (!excludedSizes.includes(size)) {
    submissionBigTeam();
  }
};

export const partnerizePixel = (id) => {
  const clickRef = localStorage.getItem("_pz_clickref");

  if (!clickRef) {
    return;
  }

  if (id) {
    applicationPartnerize(id);
    return;
  }

  bookATourPartnerize();
};

const whichModal = ($form) => {
  //  market template - bookTourForm is embedded
  const isEmbedForm = $form.parent().hasClass("market-form");
  if (isEmbedForm) {
    return $("#modal-location-form");
  }

  //  location template - schedule a call and book tour appear together
  //  dynamic landing page - two modal the same modal forms (reason: different designs)
  //  but calendly should appear as long as user submits
  const isLocation = $("body").hasClass("page-template-template-location");
  const isDynamicLandingPage = $("body").hasClass(
    "page-template-template-dynamic-landing-page"
  );
  if (isLocation || isDynamicLandingPage) {
    return $(".js-modal-with-form");
  }

  return $form.parents(".modal");
};

export const openCalendlyNotModal = ($form, calendlyLink, prefill) => {
  const $modals = whichModal($form);

  const isDynamicLandingPage = $("body").hasClass(
    "page-template-template-dynamic-landing-page"
  );

  if (isDynamicLandingPage) {
    $("#js-sidebar-form").addClass("d-none");
  }

  $modals.each(function () {
    const id = $(this).attr("id");
    const $trigger = $(`[data-target="#${id}"]`);

    $trigger.on("click", () => {
      const calendlyLinkToUse = $(this).data("calendly-link") || calendlyLink;

      if (!$("body").hasClass("js-calendly-send")) {
        Calendly.showPopupWidget(calendlyLinkToUse, null, { prefill });
      }
    });
  });
};
